var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GridColumnMenuCheckboxFilter',{attrs:{"column":_vm.column,"filter":_vm.filter,"filterable":_vm.filterable,"unique-data":_vm.uniqueData,"search-box":false,"data-items":_vm.filterItems,"expanded":true},on:{"filterchange":_vm.filterChange,"expandchange":_vm.expandChange,"closemenu":_vm.closeMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }